import { CardStack, CardStackItem } from "@/components/ui/card-stack";
import { Category } from "@/hooks/useArticles";
import { useIsMobile } from "@/hooks/use-mobile";

import followDream from "@/assets/images/follow-dream.webp";
import roadtripVan from "@/assets/images/roadtrip-van.webp";
import airplaneSunset from "@/assets/images/airplane-sunset.jpg";
import italyCoast from "@/assets/images/italy-coast.webp";
import airportSilhouette from "@/assets/images/airport-silhouette.webp";
import lakeBoat from "@/assets/images/lake-boat.webp";
import friendsMountain from "@/assets/images/friends-mountain.webp";

const categoryImages: Record<string, string> = {
  "sabbataar-intro": followDream,
  "ideer-inspiration": lakeBoat,
  "rejse-udland": italyCoast,
  "hoejskole-uddannelse": roadtripVan,
  "arbejde-frivillighed": friendsMountain,
  "kvote-2": airportSilhouette,
  "su-fremtid": airplaneSunset,
  "oekonomi-planlaegning": roadtripVan,
  "personlige-historier": lakeBoat,
  "for-foraeldre": followDream,
};

const fallbackImages = [
  followDream, roadtripVan, airplaneSunset, italyCoast,
  airportSilhouette, lakeBoat, friendsMountain,
];

interface CategoryCardStackProps {
  categories: Category[];
}

export function CategoryCardStack({ categories }: CategoryCardStackProps) {
  const isMobile = useIsMobile();

  const items: CardStackItem[] = categories.map((cat, i) => ({
    id: cat.id,
    title: cat.name,
    description: cat.description || undefined,
    imageSrc: categoryImages[cat.slug] || fallbackImages[i % fallbackImages.length],
    href: `/kategori/${cat.slug}`,
  }));

  return (
    <CardStack
      items={items}
      cardWidth={isMobile ? 320 : 480}
      cardHeight={isMobile ? 220 : 300}
      autoAdvance
      intervalMs={3500}
      pauseOnHover
      loop
      maxVisible={5}
      overlap={0.48}
      spreadDeg={40}
    />
  );
}
